import { Toolbar, ToolbarTitle } from '@/components/toolbar';
import { Button } from '@/components/button';
import ReloadIcon from '@/components/icons/reload';
import { useDashboardContext } from './hooks/use-dashboard-context';
import { DashboardToolbarProps as BaseDashboardToolbarProps } from './types';
import { ComponentPropsOverride } from '@/types';

type DashboardToolbarProps = ComponentPropsOverride<
  'div',
  BaseDashboardToolbarProps
>;

export function DashboardToolbar({
  children: _children,
  title,
  ...others
}: DashboardToolbarProps) {
  const { refresh } = useDashboardContext();

  return (
    <Toolbar {...others}>
      <ToolbarTitle>{title}</ToolbarTitle>
      <Button
        onClick={() => {
          refresh();
        }}
        variant="ghost"
        size="xs"
        className="mm:text-muted-foreground"
      >
        <ReloadIcon />
      </Button>
    </Toolbar>
  );
}

DashboardToolbar.displayName = 'DashboardToolbar';
